// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum ManualFanMode {
    AutoWeather = 'AutoWeather',
    AlwaysOff = 'AlwaysOff',
    AlwaysOn = 'AlwaysOn',
    Invalid = 'Invalid',
}
export default ManualFanMode;
